import { Glue42 } from "../../glue";
import { Cookies } from "./index";

export function factory(agm: Glue42.AGM.API, methodName: string): Glue42.Cookies.API & { ready: () => Promise<void>; } {
    const cookies = new Cookies(methodName, agm);

    return {
        get: cookies.get.bind(cookies),
        remove: cookies.remove.bind(cookies),
        set: cookies.set.bind(cookies),
        ready: () => Promise.resolve()
    };
}
